import { render, staticRenderFns } from "./stack-container-config-edit.vue?vue&type=template&id=2083de22&scoped=true&"
import script from "./stack-container-config-edit.vue?vue&type=script&lang=js&"
export * from "./stack-container-config-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2083de22",
  null
  
)

export default component.exports